import { Action } from 'shared/store/types';
import EVENTS from './actionTypes';
import { VariantsState } from './types';

const defaultState: VariantsState = {
  loading: false,
  isNotFound: false,
  isFetchingError: {},
  data: [],
  productSizeData: {},
};

interface VariantsAction extends Action {
  productId?: number;
}

const Variants = (state = defaultState, action: VariantsAction) => {
  const { type, payload } = action;
  switch (type) {
    case EVENTS.FETCH_VARIANTS_PROGRESS: {
      const { productId } = action;
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError:
          productId != null
            ? { ...state.isFetchingError, [productId]: false }
            : { ...state.isFetchingError },
        productSizeData: {
          ...state.productSizeData,
        },
      };
    }

    case EVENTS.FETCH_VARIANTS_SUCCESS: {
      const { productId } = action;
      if (productId == null || !payload) {
        return state;
      }
      return {
        ...state,
        data: {
          ...state.data,
          [productId]: payload.variants,
        },
        loading: false,
        isNotFound: false,
        isFetchingError: {
          ...state.isFetchingError,
          [productId]: false,
        },
        productSizeData: {
          ...state.productSizeData,
          [productId]: payload.productSizeData,
        },
      };
    }

    case EVENTS.FETCH_VARIANTS_NOT_FOUND: {
      const { productId } = action;
      if (productId == null) {
        return state;
      }
      return {
        ...state,
        loading: false,
        isNotFound: true,
        data: {
          ...state.data,
          [productId]: [],
        },
        isFetchingError: {
          ...state.isFetchingError,
          [productId]: true,
        },
        productSizeData: {
          ...state.productSizeData,
        },
      };
    }

    case EVENTS.FETCH_VARIANTS_FAILED: {
      const { productId } = action;
      if (productId == null) {
        return state;
      }
      return {
        ...state,
        loading: false,
        isNotFound: false,
        data: {
          ...state.data,
          [productId]: [],
        },
        isFetchingError: {
          ...state.isFetchingError,
          [productId]: true,
        },
        productSizeData: {
          ...state.productSizeData,
        },
      };
    }

    default:
      return state;
  }
};

export default Variants;
